import { useAuth0 } from '@auth0/auth0-react';
import LogoutButton from '../auth/LogoutButton';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Logo from './logo/Logo';
import LoginButton from '../auth/LoginButton';
import { useLocation } from 'react-router-dom';

const Navbar = () => {
    const { user, isAuthenticated, isLoading } = useAuth0();
    const location = useLocation();
    const isHomeRoute = location.pathname === '/';

    // use theme from local storage if available or set light theme
    const [theme, setTheme] = useState(
        localStorage.getItem('theme') ? localStorage.getItem('theme') : 'lofi',
    );

    // update state on toggle
    const handleToggle = (e) => {
        if (e.target.checked) {
            setTheme('dark');
        } else {
            setTheme('lofi');
        }
    };

    // set theme state in localstorage on mount & also update localstorage on state change
    useEffect(() => {
        localStorage.setItem('theme', theme);
        const localTheme = localStorage.getItem('theme');
        // add custom data-theme attribute to html tag required to update theme using DaisyUI
        document.querySelector('html').setAttribute('data-theme', localTheme);
    }, [theme]);

    return (
        <>
            <div>
                <header
                    className={
                        location.pathname === '/'
                            ? 'px-6  h-20 flex items-center text-black'
                            : 'px-6  h-20 flex items-center text-primary'
                    }
                >
                    {/* <a className="flex items-center justify-center text-3xl font-semibold">
                    ✏️Noteed
                    <span className="sr-only">Noteed</span>
                </a> */}
                    <a className="flex items-center justify-center text-3xl font-semibold">
                        <Logo />
                    </a>
                    <nav className="ml-auto gap-4 sm:gap-6 hidden sm:flex">
                        {isAuthenticated ? (
                            <>
                                {/* <Link
                                    className="text-sm font-medium hover:underline underline-offset-4"
                                    to="/"
                                >
                                    Home
                                </Link> */}
                                <a
                                    className="text-sm font-medium hover:underline underline-offset-4"
                                    href="#"
                                >
                                    <LogoutButton />
                                </a>
                                <label className="swap swap-rotate">
                                    {/* this hidden checkbox controls the state */}
                                    <input
                                        type="checkbox"
                                        onChange={handleToggle}
                                        // show toggle image based on localstorage theme
                                        checked={
                                            theme === 'lofi' ? false : true
                                        }
                                    />

                                    {/* sun icon */}
                                    <svg
                                        className="swap-on fill-current w-5 h-5"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                    >
                                        <path d="M5.64,17l-.71.71a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l.71-.71A1,1,0,0,0,5.64,17ZM5,12a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H4A1,1,0,0,0,5,12Zm7-7a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4A1,1,0,0,0,12,5ZM5.64,7.05a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41l-.71-.71A1,1,0,0,0,4.93,6.34Zm12,.29a1,1,0,0,0,.7-.29l.71-.71a1,1,0,1,0-1.41-1.41L17,5.64a1,1,0,0,0,0,1.41A1,1,0,0,0,17.66,7.34ZM21,11H20a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Zm-9,8a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V20A1,1,0,0,0,12,19ZM18.36,17A1,1,0,0,0,17,18.36l.71.71a1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.41ZM12,6.5A5.5,5.5,0,1,0,17.5,12,5.51,5.51,0,0,0,12,6.5Zm0,9A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Z" />
                                    </svg>

                                    {/* moon icon */}
                                    <svg
                                        className="swap-off fill-current w-5 h-5"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                    >
                                        <path d="M21.64,13a1,1,0,0,0-1.05-.14,8.05,8.05,0,0,1-3.37.73A8.15,8.15,0,0,1,9.08,5.49a8.59,8.59,0,0,1,.25-2A1,1,0,0,0,8,2.36,10.14,10.14,0,1,0,22,14.05,1,1,0,0,0,21.64,13Zm-9.5,6.69A8.14,8.14,0,0,1,7.08,5.22v.27A10.15,10.15,0,0,0,17.22,15.63a9.79,9.79,0,0,0,2.1-.22A8.11,8.11,0,0,1,12.14,19.73Z" />
                                    </svg>
                                </label>
                            </>
                        ) : (
                            <>
                                <Link
                                    className="text-sm font-medium hover:underline underline-offset-4"
                                    to="/"
                                >
                                    Home
                                </Link>
                                <a
                                    className="text-sm font-medium hover:underline underline-offset-4"
                                    href="#features"
                                >
                                    Features
                                </a>
                                <a
                                    className="text-sm font-medium hover:underline underline-offset-4"
                                    href="#reviews"
                                >
                                    Reviews
                                </a>
                                <a
                                    className="text-sm font-medium hover:underline underline-offset-4"
                                    href="#faq"
                                >
                                    Faq
                                </a>
                                <LoginButton />
                            </>
                        )}
                    </nav>

                    {/* Mobile menu */}
                    <div className="sm:hidden ml-auto">
                        <div className="dropdown dropdown-end">
                            <div
                                tabIndex={0}
                                role="button"
                                className="btn btn-ghost lg:hidden"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M4 6h16M4 12h8m-8 6h16"
                                    />
                                </svg>
                            </div>
                            <ul
                                tabIndex={0}
                                className="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow rounded-box w-52"
                            >
                                {isAuthenticated ? (
                                    <>
                                        <li>
                                            <Link
                                                className="text-sm font-medium rounded-md"
                                                to="/"
                                            >
                                                Home
                                            </Link>
                                        </li>
                                        <li>
                                            <a className="text-sm font-medium rounded-md">
                                                <LogoutButton />
                                            </a>
                                        </li>
                                        <li>
                                            <label className="swap swap-rotate">
                                                {/* this hidden checkbox controls the state */}
                                                <input
                                                    type="checkbox"
                                                    onChange={handleToggle}
                                                    // show toggle image based on localstorage theme
                                                    checked={
                                                        theme === 'lofi'
                                                            ? false
                                                            : true
                                                    }
                                                />

                                                {/* sun icon */}
                                                <svg
                                                    className="swap-on fill-current w-5 h-5"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path d="M5.64,17l-.71.71a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l.71-.71A1,1,0,0,0,5.64,17ZM5,12a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H4A1,1,0,0,0,5,12Zm7-7a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4A1,1,0,0,0,12,5ZM5.64,7.05a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41l-.71-.71A1,1,0,0,0,4.93,6.34Zm12,.29a1,1,0,0,0,.7-.29l.71-.71a1,1,0,1,0-1.41-1.41L17,5.64a1,1,0,0,0,0,1.41A1,1,0,0,0,17.66,7.34ZM21,11H20a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Zm-9,8a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V20A1,1,0,0,0,12,19ZM18.36,17A1,1,0,0,0,17,18.36l.71.71a1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.41ZM12,6.5A5.5,5.5,0,1,0,17.5,12,5.51,5.51,0,0,0,12,6.5Zm0,9A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Z" />
                                                </svg>

                                                {/* moon icon */}
                                                <svg
                                                    className="swap-off fill-current w-5 h-5"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path d="M21.64,13a1,1,0,0,0-1.05-.14,8.05,8.05,0,0,1-3.37.73A8.15,8.15,0,0,1,9.08,5.49a8.59,8.59,0,0,1,.25-2A1,1,0,0,0,8,2.36,10.14,10.14,0,1,0,22,14.05,1,1,0,0,0,21.64,13Zm-9.5,6.69A8.14,8.14,0,0,1,7.08,5.22v.27A10.15,10.15,0,0,0,17.22,15.63a9.79,9.79,0,0,0,2.1-.22A8.11,8.11,0,0,1,12.14,19.73Z" />
                                                </svg>
                                            </label>
                                        </li>
                                    </>
                                ) : (
                                    <>
                                        <li>
                                            <Link
                                                className="text-sm font-medium rounded-md"
                                                to="/"
                                            >
                                                Home
                                            </Link>
                                        </li>
                                        <li>
                                            <a
                                                className="text-sm font-medium rounded-md"
                                                href="#features"
                                            >
                                                Features
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="text-sm font-medium rounded-md"
                                                href="#upcoming"
                                            >
                                                Upcoming
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="text-sm font-medium rounded-md"
                                                href="#upcoming"
                                            >
                                                <LoginButton />
                                            </a>
                                        </li>
                                    </>
                                )}
                            </ul>
                        </div>
                    </div>
                    {/* Mobile menu END*/}
                </header>
            </div>
        </>
    );
};
export default Navbar;
